<template>
  <div class="el-section">
    <payment-boleto v-if="selectedPaymentMethod.includes('boleto')" />
    <payment-credit-card v-if="selectedPaymentMethod.includes('credit_card')" />
    <payment-link v-if="selectedPaymentMethod.includes('checkout')" />
    <payment-pix :selectedPaymentMethod='selectedPaymentMethod' />
  </div>
</template>

<script>
import PaymentBoleto from './PaymentData/PaymentBoleto'
import PaymentCreditCard from './PaymentData/PaymentCreditCard'
import PaymentLink from './PaymentData/PaymentLink'
import PaymentPix from './PaymentData/PaymentPix'
export default {
  name: 'PaymentData',
  components: {
    PaymentBoleto,
    PaymentCreditCard,
    PaymentLink,
    PaymentPix
  },
  computed: {
    selectedPaymentMethod () {
      return this.$store.getters.selectedPaymentMethod
    }
  }
}
</script>
